<div class="unpin-info-message-close" (click)="close()">
    <vn-icon name="theme-ex" size="11" />
</div>
<span>{{ sitecore.media.UnpinOnboarding }}</span>
<div class="unpin-info-message-arrow"></div>
